exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-xsmall[data-v-14b1676b] {\n  font-size: 60%;\n}", ""]);

// exports
